import React from 'react';
import { Typography } from '@hpi-sox/hpstellar-core/visId';
import { DEFAULT_BASE_TITLE, DEFAULT_ICTO_TITLE, DEFAULT_CONFIGID_TITLE } from './product-identity-details';

import './product-identity-details.less';

export default ({ className = '', iCTO, configID, baseSku }) => {
    return (
        <div className={`base-icto-config-id${className ? ' ' + className : ''}`}>
            {baseSku && (
                <Typography variant="footnotes">
                    {DEFAULT_BASE_TITLE} {baseSku}
                </Typography>
            )}
            {iCTO && (
                <Typography variant="footnotes">
                    {DEFAULT_ICTO_TITLE} {iCTO}
                </Typography>
            )}

            {configID && (
                <Typography variant="footnotes">
                    {DEFAULT_CONFIGID_TITLE} {configID}
                </Typography>
            )}
        </div>
    );
};
